import request from '@/utils/request'
const api = {
  getGift: 'gift/getGift',
  getGiftInfo: 'gift/getGiftInfo'
}
export default {
  getGift(parameter) {
    return request({
      url: api.getGift,
      method: 'POST',
      data: parameter
    })
  },
  getGiftInfo(parameter) {
    return request({
      url: api.getGiftInfo,
      method: 'POST',
      data: parameter
    })
  }
}
